import {
  ArrowRight,
  Bell,
  Box,
  Compass,
  ExternalLink,
  Ghost,
  GitPullRequest,
  Inbox,
  KeyRound,
  LayoutDashboard,
  Layers,
  LockKeyhole,
  Megaphone,
  MessageCircle,
  Play,
  Shield,
  ShieldCheck,
  Sparkles,
  TerminalSquare,
  Users,
  Workflow,
  Zap,
} from 'lucide-react';
import { createWebRegistrationFromManifest } from '@reflex/plugin-api/create-web-registration';
import { marketingWeb } from '../web-manifest.js';

export default createWebRegistrationFromManifest(
  marketingWeb,
  {
    DynamicMarketingIndexPage: () => import('./DynamicMarketingIndexPage'),
    DynamicMarketingPage: () => import('./DynamicMarketingPage'),
    MarketingHomePage: () => import('./MarketingHomePage'),
    MarketingAdminHubPage: () => import('./admin/MarketingAdminHubPage'),
    MarketingPageEditorPage: () => import('./admin/MarketingPageEditorPage'),
    MarketingPagePreviewPage: () => import('./admin/MarketingPagePreviewPage'),
    AlphaWaitlistPage: () => import('./AlphaWaitlistPage'),
  },
  {
    icons: {
      ArrowRight,
      Bell,
      Box,
      Compass,
      ExternalLink,
      Ghost,
      GitPullRequest,
      Inbox,
      KeyRound,
      LayoutDashboard,
      Layers,
      LockKeyhole,
      Megaphone,
      MessageCircle,
      Play,
      Shield,
      ShieldCheck,
      Sparkles,
      TerminalSquare,
      Users,
      Workflow,
      Zap,
    },
  },
);
